import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Chart from 'chart.js/auto';
import { UserService } from 'src/services/user.service';
import { DemoService } from 'src/services/demo.service';
import { LocalizationService } from 'src/services/localization.service';
import { texts as dashboardTexts } from '../../dashboard/dashboard.texts';
import { demoActivities, demoPoolKpis, demoPoolWeeks } from '../pool.demo';

@Component({
  selector: 'app-pool-activities',
  standalone: false,
  templateUrl: './pool-activities.component.html',
  styleUrls: ['./pool-activities.component.scss']
})
export class PoolActivitiesComponent implements OnDestroy {

  @Input()
  pool : any;

  // the dashboard's pool labels, so both views name the figures alike
  poolTexts = dashboardTexts.pool;

  poolWeeks = demoPoolWeeks;

  poolKpis = demoPoolKpis;

  poolChart?: Chart;

  // the pool card only renders in demo mode, so the chart follows its canvas
  @ViewChild('poolChart')
  set poolChartCanvas(canvas: ElementRef<HTMLCanvasElement>) {
    this.poolChart?.destroy();
    this.poolChart = canvas ? this.createPoolChart(canvas.nativeElement) : undefined;
  }

  // Demo data - no API/controller logic yet. Replace with real data later.
  kpis : any = {
    CandidateCount: 842,
    CandidateCountTrend: '+8 % in 30 Tagen',
    SwitchSignals: 37,
    SwitchSignalsTrend: '+40 % in 30 Tagen',
    Engagements: 126,
    EngagementsTrend: '+23 % in 30 Tagen'
  };

  // the pool of a company is its own, so the feed needs no id
  activitiesUri = 'pool/activities';

  // ?obfuscate shows the hardcoded demo feed instead of the company's activities
  obfuscate = false;

  // Demo data, shown with ?obfuscate.
  demoActivities : any = demoActivities;

  constructor(public userService : UserService, private route : ActivatedRoute, private router : Router, public demo : DemoService, private loc : LocalizationService) {
    this.obfuscate = this.route.snapshot.queryParams['obfuscate'] != null;
  }

  navigate(activity : any) {
    if (activity?.Candidate) this.router.navigate(['/candidates', activity.Candidate.Id]);
  }

  createPoolChart(canvas: HTMLCanvasElement) {

    return new Chart(canvas, {
      type: 'bar',
      data: {
        labels: this.poolWeeks.map(w => w.Label),
        datasets: [
          {
            label: this.poolTexts.size[this.loc.language],
            data: this.poolWeeks.map(w => w.Value),
            backgroundColor: 'rgba(0,98,215,0.8)',
            borderColor: 'rgba(0,98,215,0.8)',
            borderRadius: 8,
            // half the default bar width (0.9)
            barPercentage: 0.45
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.poolChart?.destroy();
  }

}
